if (!customElements.get('ly-main-product-overview')) {
    customElements.define('ly-main-product-overview', class extends HTMLElement {
        #media = window.matchMedia('(min-width: 768px)')

        connectedCallback() {
            this.poppers = [...this.querySelectorAll('ly-popover-v4')]

            this.#media.addEventListener('change', this.handleMediaChange)
        }

        disconnectedCallback() {
            this.#media.removeEventListener('change', this.handleMediaChange)
        }

        handleMediaChange = () => {
            this.poppers.forEach(popper => popper.close())
        }

    })
}

if (!customElements.get('ly-main-product-overview-item-popover-scroller')) {
    customElements.define('ly-main-product-overview-item-popover-scroller', class extends LyFullScrollCarousel {
        connectedCallback() {
            super.connectedCallback()

            this.variantChangeUnsubscriber = window.subscribe('bus:active_variant_id_changed', this.debouncedHandleVariantChange)
        }

        disconnectedCallback() {
            this.variantChangeUnsubscriber()

            super.disconnectedCallback()
        }

        debouncedHandleVariantChange = debounce((newVariantId) => {
            const index = this._items.findIndex(item => {
                const ids = item.dataset.variantIds.split(',')
                return ids.includes(newVariantId)
            })
            if (index !== -1) {
                this._index = index
            }
        }, 400)
    })
}